// extracted by mini-css-extract-plugin
export default {"modalItem":"user-creation_modalItem__ChPr0","modalError":"user-creation_modalError__B-Kjk"};